import { Box, CssBaseline } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router-dom';

const MobileLayout = () => {
    return (
        <CssBaseline>
            <Box sx={{ background: (t) => t.palette.loginBackground.main }}>
                <Outlet />
            </Box>
        </CssBaseline>
    );
};

export default MobileLayout;
